export enum ECertificationType {
  ADDENDUM = 'ADDENDUM',
  ADDON = 'ADDON',
  CERTIFICATION = 'CERTIFICATION',
}

export interface ICertificationBody {
  id: string;
  name: string;
}

export interface ICertificationTypeAndAddOn {
  canHaveAddon: boolean;
  certification: string;
  certificationBodies: ICertificationBody[];
  certificationId: string;
  certificationType: ECertificationType;
  classification: string;
  combinableCertificationTypes: ICertificationTypeAndAddOn[];
  description: string;
  exception: string;
  id: string;
  key: string;
  recognizedByGFSI: boolean;
  rule: string;
  scheme: string;
  status: string;
  version: string;
  versionDescription: string;
}
